import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, change as changeFieldValue } from "redux-form";
import { SelectInput, StyledCheckboxInput, TextInput } from "../../../../../common/form";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import categorisationClientTypeTypes from "../enums/categorisationClientTypeTypes";
import categorisationProvenanceTypes, { DIRECT, BROKER } from "../enums/categorisationProvenanceTypes";
import categorisationRequirementLevelTypes from "../enums/categorisationRequirementLevelTypes";
import categorisationNotoriety from "../enums/categorisationNotorietyTypes";
import categorisationVIPClassificationTypes from "../enums/categorisationVIPClassificationTypes";
import categorisationRetirementPlanTypes from "../enums/categorisationRetirementPlanTypes";
import categorisationCurrentAssetTypes from "../enums/categorisationCurrentAssetTypes";

import { BROKERS } from "../../../../../../utils/data/models";
import * as dataActions from "../../../../../../utils/data/dataActions";
import { bindActionCreators } from "redux";
import { INFORMATION_AGENT, PLAN_ADMINISTRATOR } from "../../../../../../utils/Roles";
import _ from "lodash";
import { Link } from "react-router";
import { convertBlankOptionToNull } from "../../premiumSimulator/utils";
import { toast } from "react-toastify";

class CategorisationCategoryFields extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.setVIPCheck = this.setVIPCheck.bind(this);
        this.handleProvenanceSelect = this.handleProvenanceSelect.bind(this);

        this.state = {
            isVipChecked: false,
            selectedProvenance: null,
            allBrokers: [],
        };
    }

    componentDidMount() {
        const { initialValues } = this.props;

        if (initialValues) {
            if (initialValues.vipClassification) {
                this.props.changeFieldValue("categorisationForm", "vipClient", true);
                this.setState({ isVipChecked: true });
            }

            if (initialValues.provenance && [BROKER.value, DIRECT.value].includes(initialValues.provenance)) {
                this.setBrokerOptions();
                this.setState({ selectedProvenance: initialValues.provenance });
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { refreshInitialValues, initialValues } = this.props;
        if (prevProps.refreshInitialValues !== refreshInitialValues && refreshInitialValues !== 0) {
            this.setState({ isVipChecked: !!initialValues.vipClient });
            if (initialValues.provenance === BROKER.value) {
                this.setBrokerOptions();
            }
            this.setState({ selectedProvenance: initialValues.provenance });
        }
    }

    setVIPCheck(e) {
        this.props.changeFieldValue("categorisationForm", "vipClassification", null);
        this.props.changeFieldValue("categorisationForm", "vipClient", false);
        this.setState({ isVipChecked: e.target.checked });
        return e.target.checked;
    }

    handleProvenanceSelect(e) {
        const { value } = e.target;
        this.setState({ selectedProvenance: value });

        if (value === BROKER.value) {
            this.props.changeFieldValue("categorisationForm", "referenceUserId", null);
            this.setBrokerOptions();
        }
        this.props.changeFieldValue("categorisationForm", "referenceUserId", null);
        this.props.changeFieldValue("categorisationForm", "referenceBrokerId", null);
    }

    setBrokerOptions() {
        this.props.dataActions
            .getDataList(BROKERS, 0, 0, "", ["fullName:asc"], ["brokers.isArchived==false"])
            .then((res) => {
                const { items } = res.payload.data;

                const allBrokers = items.map(({ brokerId, fullName }) => {
                    return {
                        value: brokerId,
                        text: fullName,
                    };
                });

                this.setState({ allBrokers });
            })
            .catch(() => {
                toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
    }

    render() {
        const { userList, clientId, required } = this.props;
        const { isVipChecked, selectedProvenance, allBrokers } = this.state;

        return (
            <div>
                <h3>
                    <FormattedMessage id="clients.client.categorisation.categoryForm.title" />
                </h3>
                <div className="form-width">
                    <Field
                        id="clientType"
                        name="clientType"
                        component={SelectInput}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        normalize={(value) => convertBlankOptionToNull(value)}
                        options={categorisationClientTypeTypes}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.clientType" />}
                    />
                    <Field
                        id="provenance"
                        name="provenance"
                        component={SelectInput}
                        normalize={(value) => convertBlankOptionToNull(value)}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        props={{ onChange: this.handleProvenanceSelect }}
                        options={categorisationProvenanceTypes}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.provenance" />}
                    />
                    {selectedProvenance === DIRECT.value && (
                        <Field
                            id="referenceUserId"
                            name="referenceUserId"
                            component={SelectInput}
                            addBlankOption={true}
                            blankMessageKey="common.blank"
                            normalize={(value) => convertBlankOptionToNull(value)}
                            options={userList}
                            label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.reference" />}
                        />
                    )}
                    {selectedProvenance === BROKER.value && allBrokers && (
                        <Field
                            id="referenceBrokerId"
                            name="referenceBrokerId"
                            component={SelectInput}
                            addBlankOption={true}
                            blankMessageKey="common.blank"
                            normalize={(value) => convertBlankOptionToNull(value)}
                            options={this.state.allBrokers}
                            label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.brokerName" />}
                        />
                    )}
                    <Field
                        id="requirementLevel"
                        name="requirementLevel"
                        component={SelectInput}
                        normalize={(value) => convertBlankOptionToNull(value)}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        options={categorisationRequirementLevelTypes}
                        label={
                            <FormattedMessage id="clients.client.categorisation.categoryForm.form.requirementLevel" />
                        }
                    />
                    <Field
                        id="notoriety"
                        name="notoriety"
                        component={SelectInput}
                        normalize={(value) => convertBlankOptionToNull(value)}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        options={categorisationNotoriety}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.notoriety" />}
                    />
                    <Field
                        id="vipClient"
                        name="vipClient"
                        type="checkbox"
                        className="vipClientCheckbox"
                        component={StyledCheckboxInput}
                        props={{ onChange: this.setVIPCheck }}
                        checkbox={{ value: true }}
                        label={<FormattedHTMLMessage id="clients.client.categorisation.categoryForm.form.vipClient" />}
                        normalize={(value) => !!value}
                    />
                    {isVipChecked && (
                        <Field
                            id="vipClassification"
                            name="vipClassification"
                            component={SelectInput}
                            options={categorisationVIPClassificationTypes}
                            label={
                                <FormattedMessage id="clients.client.categorisation.categoryForm.form.vipClassification" />
                            }
                        />
                    )}
                    <Field
                        id="insurers"
                        name="insurers"
                        component={TextInput}
                        disabled={true}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.insurers" />}
                    />

                    <div className="mb-1">
                        <Link to={`dashboard/clients/${clientId}/client-coverages`}>
                            <FormattedMessage id="clients.client.categorisation.categoryForm.clientCoveragesRedirection" />
                        </Link>
                    </div>

                    <Field
                        id="retirementPlan"
                        name="retirementPlan"
                        component={SelectInput}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        normalize={(value) => convertBlankOptionToNull(value)}
                        options={categorisationRetirementPlanTypes}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.retirementPlan" />}
                    />
                    <Field
                        id="currentAssets"
                        name="currentAssets"
                        component={SelectInput}
                        addBlankOption={!required}
                        sortOptions={false}
                        blankMessageKey="common.blank"
                        normalize={(value) => convertBlankOptionToNull(value)}
                        options={categorisationCurrentAssetTypes}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.currentAssets" />}
                    />
                    <Field
                        id="seller"
                        name="seller"
                        component={TextInput}
                        label={<FormattedMessage id="clients.client.categorisation.categoryForm.form.seller" />}
                    />
                </div>
            </div>
        );
    }
}

CategorisationCategoryFields.propTypes = {
    clientClassification: PropTypes.object,
    dataActions: PropTypes.object,
    userList: PropTypes.array,
    changeFieldValue: PropTypes.func,
    initialValues: PropTypes.object,
    refreshInitialValues: PropTypes.number,
    clientId: PropTypes.number,
    required: PropTypes.bool,
    disabled: PropTypes.bool
};

function mapStateToProps(state) {
    const userData = state.data.users ? state.data.users : [];
    let users = _.get(userData, "items") || [];
    const filteredUsers = users.filter(
        ({ roleId }) => ![INFORMATION_AGENT.roleId, PLAN_ADMINISTRATOR.roleId].includes(roleId)
    );
    const userList = filteredUsers.map(({ userId, firstName, lastName }) => ({
        value: userId,
        text: `${firstName} ${lastName}`,
    }));
    return {
        userList: userList || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CategorisationCategoryFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/forms/CategorisationCategoryFields.js